import { render, staticRenderFns } from "./SelectFolder.vue?vue&type=template&id=7cd70b3a&scoped=true&"
import script from "./SelectFolder.vue?vue&type=script&lang=ts&"
export * from "./SelectFolder.vue?vue&type=script&lang=ts&"
import style0 from "./SelectFolder.vue?vue&type=style&index=0&id=7cd70b3a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd70b3a",
  null
  
)

export default component.exports